import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { message } from 'antd';
import WalkingSpinner from '../../components/spinner/WalkingSpinner';
import oauthApi from '../../services/oauthApi';
import { OAuthProviderType } from '../../data/enums';
import { useSelector } from 'react-redux';
const CloverCallback = () => {
  const globalCompany = useSelector((state) => state.companyReducer.selected);
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const Code = params.get('code');
  const error = params.get('error');
  const EmployeeId = params.get('employee_id');
  const MerchantId = params.get('merchant_id');
  const states = params.get('state');
  const statePayload = JSON.parse(decodeURIComponent(states));
  console.log(statePayload);
  console.log(Code, error, EmployeeId, MerchantId);

  useEffect(() => {
    if (error) {
      message.error('Clover OAuth failed: ' + error);
      setLoading(false);
      navigate('/dashboard/settings/integrations');
      return;
    }

    if (!Code) {
      message.error('Clover OAuth failed: Authorization code missing.');
      setLoading(false);
      navigate('/dashboard/settings/integrations');
      return;
    }

    const integrateClover = async () => {
      setLoading(true);

      await connectClover();

      try {
        const body = {
          companyId: globalCompany.id,
          storeId: statePayload.storeId,
          type: OAuthProviderType.Clover,
          isIntegrated: true,
          locationId: MerchantId,
        };
        await oauthApi.postIntegrationStoreLocation(body);
        message.success('Store integrated with Clover successfully');
      } catch (error) {
        console.error('Error with integration', error);
      } finally {
        setLoading(false);
        navigate('/dashboard/settings/integrations');
      }
    };

    const connectClover = async () => {
      try {
        const query = {
          Code,
          Type: OAuthProviderType.Clover,
          CompanyId: globalCompany.id,
          EmployeeId,
          MerchantId,
          RedirectUri:
            window.location.origin + '/dashboard/settings/clover/callback',
        };

        await oauthApi.callback(query);
        message.success('Clover connected successfully!');
      } catch (err) {
        console.error('Clover OAuth submission failed', err);
        const errorMessage =
          err.response?.data?.Message ||
          err.message ||
          'Failed to connect Clover.';
        message.error(errorMessage);
      }
    };

    integrateClover();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Code, error, globalCompany.id, EmployeeId, MerchantId, navigate]);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-4">
        <WalkingSpinner size={88} />
        <p className="text-sm font-medium text-slate-500 dark:text-slate-400">
          Connecting to Clover...
        </p>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-screen">
      <p>Processing Clover authentication...</p>
    </div>
  );
};

export default CloverCallback;
